import workspaceQuery from 'graphql/queries/purchases/PurchaseOrderLineWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/purchases/PurchaseOrderLineListQuery.graphql';
import instanceQuery from 'graphql/queries/purchases/PurchaseOrderLineQuery.graphql';
import fragment from 'graphql/fragments/purchases/PurchaseOrderLineFragment.graphql';

const PurchaseOrderLine = {
  type: 'PurchaseOrderLine',
  title: 'Purchase Order Lines',
  workspaceUrl: '/Purchasing/OrderItem/Workspace',
  instance: instanceQuery,
  workspace: workspaceQuery,
  formUrl: '/Purchasing/Order/Details/',
  formTitle: 'Purchase Orders',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'id',
    remoteFilter: true,
  },
  fragment,
  screenReference: 'PURCHASING_ORDER_LINES',
};

export default PurchaseOrderLine;
